import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
export function Redirect(props) { const nav = useNavigate(); useEffect(() => { nav(props.to); }, [nav, props.to]); return null; }
